AppName.Modules.ThemeModule = (function() {
  //Dependencies
  var core = AppName.Core;

  //////////////////////
  // Private Methods //
  ////////////////////
  var _homeSlider = function() {
    $('.featured-slider').slick({
      lazyLoad: 'ondemand',
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      cssEase: 'linear',
      nextArrow: '<i class="slick-next fas fa-chevron-right"></i>',
      prevArrow: '<i class="slick-prev fas fa-chevron-left"></i>',
      // responsive: [
      //   {
      //     breakpoint: 600,
      //     settings: {
      //       dots: false,
      //     }
      //   },
      //   {
      //     breakpoint: 480,
      //     settings: {
      //       dots: false,
      //     }
      //   }
      // ]
    });
  };

  var _header = function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 1){
        $('header').addClass("sticky-animated");
      }
      else {
        $('header').removeClass("sticky-animated");
      }
    });
  }

  var _reviews = function() {
    $('.reviews').slick({
      lazyLoad: 'ondemand',
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      nextArrow: '<i class="slick-next btn-slick fas fa-chevron-right"></i>',
      prevArrow: '<i class="slick-prev btn-slick fas fa-chevron-left"></i>',
      // responsive: [
      //   {
      //     breakpoint: 600,
      //     settings: {
      //       dots: false,
      //     }
      //   },
      //   {
      //     breakpoint: 480,
      //     settings: {
      //       dots: false,
      //     }
      //   }
      // ]
    });
  };

  var _addons = function() {
    $('.addons-carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      nextArrow: '<i class="slick-next fas fa-chevron-right"></i>',
      prevArrow: '<i class="slick-prev fas fa-chevron-left"></i>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            dots: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            dots: false,
          }
        }
      ]
    });
  };

  var _slideShowProducts = function() {
    $('.image-view-option').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      nextArrow: '<i class="slick-next fas fa-chevron-right"></i>',
      prevArrow: '<i class="slick-prev fas fa-chevron-left"></i>',
    });
  };

  var _productDetails = function() {
      $('input[type="checkbox"]').change(function() {
        if ($(this).is(':checked')) {
            $(this).parent('label').addClass("border-brand-gradient");
        } else {
            $(this).parent('label').removeClass("border-brand-gradient");
        }
      });
  }
  
  var _toggle = function() {
    $(".looking-for").click(function(){
      $(".search-arrow").toggleClass("reverse");
      $(".modal-search").toggleClass("show");
      $(".modal-budget").removeClass("show");
      $(".budget-arrow").removeClass("reverse");
    });

    $(".budget").click(function(){
      $(".budget-arrow").toggleClass("reverse");
      $(".modal-budget").toggleClass("show");
      $(".modal-search").removeClass("show");
      $(".search-arrow").removeClass("reverse");
    });
  }

  /////////////////////
  // Public Methods //
  ///////////////////
  var init = function() {
    _homeSlider();
    _header();
    _reviews();
    _addons();
    _slideShowProducts();
    _productDetails();
    _toggle();
  };

  return {
    init: init
  };
})();
